export function deleteFilter(filterID){
    return window.gapi.client.request({
        path: "https://www.googleapis.com/gmail/v1/users/me/settings/filters/" + filterID,
        method:"DELETE",
    })
}

export function addTrashLabel(email){
    return window.gapi.client.request({
        path: "https://www.googleapis.com/gmail/v1/users/me/settings/filters",
        method:"POST",
        body: { "criteria": {"from": email},
        "action": {"addLabelIds":["TRASH"]}}
    })
}

export function refreshToken(useremail){
        const config =  {
            response_type: 'permission',
            scope: "https://www.googleapis.com/auth/gmail.modify",
            client_id: "897894816961-v2mhc06e43r07gjtmnmeg0o2rbg0emgi.apps.googleusercontent.com",
            login_hint: useremail,
            prompt: 'none',
            immediate: true
        }
        window.gapi.auth2.authorize(config, function(response) {
            let initConfig = {discoveryDocs:[
                "https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest"
                ]}
            window.gapi.client.init(initConfig).then(()=>{
                console.log('token refreshed')
            })
        })
}